import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons/faMapMarker';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faRoad } from '@fortawesome/free-solid-svg-icons/faRoad';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faCode } from '@fortawesome/free-solid-svg-icons/faCode';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faAndroid } from '@fortawesome/free-brands-svg-icons/faAndroid';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons/faArrowCircleDown';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons/faPlayCircle';
import { faStopCircle } from '@fortawesome/free-solid-svg-icons/faStopCircle';
import { faCar } from '@fortawesome/free-solid-svg-icons/faCar';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkedAlt';

// Explicitly import and add only the needed icons for fontawesome to minimize
// our package size.
library.add(
  faDatabase,
  faDownload,
  faPlusCircle,
  faInfoCircle,
  faMapMarker,
  faMapMarkerAlt,
  faPhone,
  faPlus,
  faQuestionCircle,
  faRoad,
  faSearch,
  faTimesCircle,
  faKey,
  faClock,
  faCreditCard,
  faFilter,
  faCode,
  faApple,
  faAndroid,
  faArrowCircleDown,
  faPlayCircle,
  faStopCircle,
  faCar,
  faMapMarkedAlt,
);

const FontAwesomeIconLib = {
  install(Vue) {
    Vue.component('font-awesome-icon', FontAwesomeIcon);
  },
};

export default FontAwesomeIconLib;
